import React from 'react';

/**
 * Marca ReportFIUS — símbolo ou lockup (símbolo + wordmark).
 *
 * O pacote de logo veio em duas famílias porque o wordmark muda de cor: numa é
 * branco, na outra é navy. Não dá para unificar em um arquivo só, então `tone`
 * declara o FUNDO em que a marca vai ficar, não a cor da arte:
 *
 *   tone="light" → sobre fundo claro (arte saturada, wordmark navy)
 *   tone="dark"  → sobre fundo escuro (arte clara, wordmark branco)
 *
 * Escolher errado faz o wordmark sumir no fundo. Os arquivos ficam em
 * `public/images/brand`; os masters de origem, em `design-system/brand-source`.
 */

const SIZES = {
  icon: [64, 128, 256, 512],
  lockup: [64, 128, 256],
};

/** Menor arquivo que ainda atende 2x (retina) na altura pedida. */
const pickAsset = (variant, height) => {
  const target = height * 2;
  const options = SIZES[variant];
  return options.find((s) => s >= target) || options[options.length - 1];
};

const BrandMark = ({
  variant = 'icon',
  tone = 'light',
  height = 40,
  className = '',
  alt = 'ReportFIUS',
  decorative = false,
  ...rest
}) => {
  const asset = pickAsset(variant, height);
  const file = `reportfius-${variant === 'lockup' ? 'logo' : 'icon'}-${tone}-${asset}.png`;

  return (
    <img
      src={`${process.env.PUBLIC_URL || ''}/images/brand/${file}`}
      alt={decorative ? '' : alt}
      aria-hidden={decorative ? 'true' : undefined}
      // Altura fixa + largura automática: o lockup não é quadrado e esticá-lo
      // deformaria o wordmark.
      style={{ height, width: 'auto' }}
      className={`shrink-0 select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
};

export default BrandMark;
